<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<h2 class="fm_title">Glossary</h2>
<table>
<tbody><tr>
<td class="tab1"><span href="#/xhtml/11_Chapter_04#rgloss1" id="gloss1" title="Link target outside of Sample">Capt</span></td>
<td class="tab2">Captain</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/16_Epilogue#rgloss2" id="gloss2" title="Link target outside of Sample">CND</span></td>
<td class="tab2">Campaign for Nuclear Disarmament</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/09_Chapter_02#rgloss3" id="gloss3" title="Link target outside of Sample">Col</span></td>
<td class="tab2">Colonel</td>
</tr>
<tr>
<td class="tab1"><a href="#/xhtml/06_Acknowledgements#rgloss4" id="gloss4">DL</a></td>
<td class="tab2">Deputy Lieutenant</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/10_Chapter_03#rgloss5" id="gloss5" title="Link target outside of Sample">DSO</span></td>
<td class="tab2">Distinguished Service Order</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/14_Chapter_07#rgloss6" id="gloss6" title="Link target outside of Sample">EIS</span></td>
<td class="tab2">Educational Institute of Scotland</td>
</tr>
<tr>
<td class="tab1"><a href="#/xhtml/08_Chapter_01#rgloss7" id="gloss7">HLI</a></td>
<td class="tab2">Highland Light Infantry</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/10_Chapter_03#rgloss8" id="gloss8" title="Link target outside of Sample">Lt</span></td>
<td class="tab2">Lieutenant</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/12_Chapter_05#rgloss9" id="gloss9" title="Link target outside of Sample">Maj</span></td>
<td class="tab2">Major</td>
</tr>
<tr>
<td class="tab1"><a href="#/xhtml/08_Chapter_01#rgloss10" id="gloss10">OTC</a></td>
<td class="tab2">Officer Training Corps</td>
</tr>
<tr>
<td class="tab1">RA</td>
<td class="tab2">Royal Artillery</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/16_Epilogue#rgloss11" id="gloss11" title="Link target outside of Sample">RAF</span></td>
<td class="tab2">Royal Air Force</td>
</tr>
<tr>
<td class="tab1"><a href="#/xhtml/08_Chapter_01#rgloss12" id="gloss12">RAMC</a></td>
<td class="tab2">Royal Army Medical Corps</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/09_Chapter_02#rgloss13" id="gloss13" title="Link target outside of Sample">RE</span></td>
<td class="tab2">Royal Engineers</td>
</tr>
<tr>
<td class="tab1"><a href="#/xhtml/06_Acknowledgements#rgloss14" id="gloss14">RHF</a></td>
<td class="tab2">Royal Highland Fusiliers</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/11_Chapter_04#rgloss15" id="gloss15" title="Link target outside of Sample">RSA</span></td>
<td class="tab2">Royal Society of Arts</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/15_Chapter_08#rgloss16" id="gloss16" title="Link target outside of Sample">SCM</span></td>
<td class="tab2">Student Christian Movement</td>
</tr>
<tr>
<td class="tab1">TA</td>
<td class="tab2">Territorial Army</td>
</tr>
<tr>
<td class="tab1">TD</td>
<td class="tab2">Territorial Decoration</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/09_Chapter_02#rgloss17" id="gloss17" title="Link target outside of Sample">WAAC</span></td>
<td class="tab2">Women’s Army Auxiliary Corps</td>
</tr>
<tr>
<td class="tab1"><span href="#/xhtml/14_Chapter_07#rgloss18" id="gloss18" title="Link target outside of Sample">WEA</span></td>
<td class="tab2">Workers’ Educational Association <a id="page_x"></a></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Glossary.vue?1b0bab3a